import { Link } from 'react-router-dom';
import { Navbar } from '@/components/Navbar';
import { Footer } from '@/components/Footer';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';

const faqs = [
  {
    q: 'What is AssistlyAI?',
    a: 'AssistlyAI is an AI assistant you use inside WhatsApp. You can schedule meetings, set reminders, summarise notes, manage calendar-related tasks, and chat in English, Hindi, or Hinglish — without installing another app.',
  },
  {
    q: 'Can I upload documents or photos?',
    a: 'Yes. You can share PDFs, tickets, or images (for example a boarding pass). AssistlyAI can store what you send in context of the service so you can ask later for specific details — like a PNR, date, or flight time — in plain language.',
  },
  {
    q: 'Do I need to download an app?',
    a: 'No. If you already use WhatsApp, you can start by messaging our number. Everything happens in chat.',
  },
  {
    q: 'Is my data private?',
    a: 'We process your messages to run the assistant. See our Privacy Policy for what we collect, how we use it, and your choices. Your WhatsApp use is also subject to Meta’s policies.',
  },
  {
    q: 'How does pricing work?',
    a: 'Plans and pricing in INR are shown on our Pricing section. Paid features depend on the plan you choose; you can cancel according to the terms that apply at signup.',
  },
  {
    q: 'Something is not working — what should I do?',
    a: 'Use the Contact page to reach us on WhatsApp or send a message through the form. We will help troubleshoot billing, access, or feature issues.',
  },
];

export function FAQs() {
  return (
    <div className="min-h-screen bg-white dark:bg-slate-950 flex flex-col">
      <Navbar />
      <main className="flex-1 pt-24 pb-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mx-auto w-full">
          <Link
            to="/"
            className="text-sm font-medium text-[#25D366] hover:text-[#1DA851] transition-colors mb-8 inline-block"
          >
            ← Back to home
          </Link>
          <h1 className="text-3xl sm:text-4xl font-bold text-slate-900 dark:text-white mb-2">
            FAQs
          </h1>
          <p className="text-slate-600 dark:text-slate-400 mb-10">
            Quick answers about AssistlyAI. Still stuck?{' '}
            <Link to="/contact" className="text-[#25D366] hover:underline font-medium">
              Contact us
            </Link>
            .
          </p>

          <Accordion type="single" collapsible className="w-full border border-slate-200 dark:border-slate-700 rounded-2xl px-4 bg-slate-50/50 dark:bg-slate-900/30">
            {faqs.map((item, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-slate-200 dark:border-slate-700">
                <AccordionTrigger className="text-left text-slate-900 dark:text-white hover:no-underline py-4">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="text-slate-600 dark:text-slate-400 pb-4 leading-relaxed">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </main>
      <Footer />
    </div>
  );
}
